export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9914.0e3df136.jpg";